<template>
    <section>
        <card :user="user" :api_prefix="api_prefix" :child_customer_id="child_customer_id"></card>
    </section>
</template>

<script>
import Card from "@/components/Card.vue";

export default {
  props: ['user', 'api_prefix'],
  data: function () 
  {
    return {
        child_customer_id: null
    }
  },
  mounted: function() 
    {
      this.child_customer_id = this.$route.params.child_customer_id;
    },
    components: {
        'card': Card,
    },
  methods:
  {
    
    },
}
</script>

<style scoped>
</style>